export const portalTypeStorageKeyName = "portal-type";

export const restorePortalToStorageKeyName = "restore-portal-to";
